import { SVGProps, Ref, forwardRef } from 'react';

export const ChartBarOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="M5.366 11.997V7.998h-1.4v4z" fill="currentColor" />
                <path d="M8.698 4v7.997h-1.4V4z" fill="currentColor" />
                <path d="M12.03 11.997V6.665h-1.4v5.332z" fill="currentColor" />
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M.5 8C.5 1.438 1.438.5 8 .5s7.5.938 7.5 7.5-.937 7.5-7.5 7.5S.5 14.563.5 8m1.4 0c0-1.63.06-2.807.225-3.681.162-.86.4-1.286.654-1.54.253-.253.68-.492 1.54-.654C5.192 1.96 6.37 1.9 8 1.9s2.808.06 3.681.225c.86.162 1.287.4 1.54.654s.492.68.654 1.54c.165.874.225 2.051.225 3.681s-.06 2.808-.225 3.682c-.162.86-.4 1.286-.654 1.54-.253.253-.68.491-1.54.653-.873.165-2.051.225-3.681.225s-2.808-.06-3.681-.225c-.86-.162-1.287-.4-1.54-.654-.253-.253-.492-.68-.654-1.54-.165-.873-.225-2.05-.225-3.68"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
ChartBarOutlinedSize16Glyph.displayName = 'ChartBarOutlinedSize16Glyph';
